<template>
  <div class="service">
  </div>
</template>

<script>
import Service from './Service'
export default {
  components: {
    Service
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/service/Loading.vue